import { render, staticRenderFns } from "./Discord.vue?vue&type=template&id=3674f97a&scoped=true"
import script from "./Discord.vue?vue&type=script&lang=js"
export * from "./Discord.vue?vue&type=script&lang=js"
import style0 from "./Discord.vue?vue&type=style&index=0&id=3674f97a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3674f97a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/nodejs-standardization-global-v2.0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3674f97a')) {
      api.createRecord('3674f97a', component.options)
    } else {
      api.reload('3674f97a', component.options)
    }
    module.hot.accept("./Discord.vue?vue&type=template&id=3674f97a&scoped=true", function () {
      api.rerender('3674f97a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/social/Discord.vue"
export default component.exports